<template>
	<inertia-head title="FAQs" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">FAQs</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Frequently asked questions
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		<div class="block block-rounded">
			<div class="block-content block-content-full">
				<p></p>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: AuthLayout,
	setup() {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
	},
}
</script>
